<ng-template #persons>
  <span [ngClass]="{ 'font-[600]': boldNumber }">{{doublepersons? _persons * 2 : _persons}}</span>
  <ng-content></ng-content>
</ng-template>

<div class="flex flex-row bg-e-white rounded-full h-full w-full px-[0.25rem]" [ngClass]="[_small ? 'gap-[0.4rem] py-[0.25rem]' : 'gap-[0.2rem]', colorscheme]">
  @if (editable) {
    <button class="disabled:opacity-25 w-1/4 my-auto" aria-label="{{'common.reduce_persons' | translate}}" [ngClass]="_small ? 'leading-[1] bg-e-dark-green text-white w-[1.375rem] h-[1.1875rem] rounded-[1rem] flex-shrink-0' : ''" [disabled]="_persons === minpersons" (click)="changePersonQty(-1)" id="minuspersonqty">
      <i class="bi bi-dash" [ngClass]="_small ? 'reset-align text-[1.2rem] block' : 'text-[1.25rem] leading-[2.0625rem]'"></i>
    </button>
    <span class="text-[0.75rem] flex gap-1 flex-row flex-nowrap justify-center w-1/2 my-auto" [ngClass]="_small ? '' : 'leading-[2.0625rem]'">
      <ng-container *ngTemplateOutlet="persons"></ng-container>
    </span>
    <button class="disabled:opacity-25 w-1/4 my-auto" aria-label="{{'common.increase_persons' | translate}}" [ngClass]="_small ? 'leading-[1] bg-e-dark-green text-white w-[1.375rem] h-[1.1875rem] rounded-[1rem] flex-shrink-0' : ''" [disabled]="_persons === maxpersons" (click)="changePersonQty(1)" id="pluspersonqty">
      <i class="bi bi-plus" [ngClass]="_small ? 'reset-align text-[1.2rem] block' : 'leading-[2.0625rem] text-[1.25rem]'"></i>
    </button>
  }
  @if (!editable) {
    <span class="text-[0.75rem] flex gap-1 flex-row flex-nowrap justify-center px-[0.5rem]" [ngClass]="_small ? '' : 'leading-[2.0625rem]'">
      <ng-container *ngTemplateOutlet="persons"></ng-container>
    </span>
  }
</div>

